export default [
    {
        title: 'Produccion',
        fontIcon: 'industry',
        resource: 'Produccion',
        action: 'ver-produccion',
        children: [
            {
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Produccion',
                action: 'ver-produccion-dashboard',
                route: 'produccion-dashboard',
                children: [
                    {
                        route: 'produccion-dashboard-pt-conteo',
                        title: 'produccion.dashboard.pt_conteo.titulo',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-dashboard-pt-conteo',
                    },
                ],
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Produccion',
                action: 'ver-produccion-configuracion',
                children: [
                    {
                        route: 'produccion-configuracion-pt-conteo',
                        title: 'produccion.configuracion.pt_conteo.titulo',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-configuracion-pt-conteo',
                    },
                ],
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Produccion',
                action: 'ver-produccion-mantenimiento',
                children: [
                    {
                        route: 'produccion-canasta-etiqueta',
                        title: 'Generacion Etiquetas',
                        resource: 'Produccion',
                        action: 'ver-produccion-generacion-etiqueta',
                    },
                    {
                        route: 'produccion-reclutamiento',
                        title: 'Reclutamiento',
                        resource: 'Produccion',
                        action: 'ver-produccion-registro-reclutamiento',
                    },
                    {
                        route: 'produccion-creacion-item',
                        title: 'Creación de Item',
                        resource: 'Produccion',
                        action: 'ver-produccion-creacion-item',
                    },
                    {
                        route: 'produccion-creacion-orden',
                        title: 'Creación de Orden de Prod.',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-creacion-orden-produccion',
                    },
                    {
                        route: 'produccion-mantenimiento-items',
                        title: 'Items',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-items',
                    },
                    {
                        route: 'produccion-mantenimiento-area-mapeo-virtual',
                        title: 'Area de Mapeo Virtual',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-area-mapeo-virtual',
                    },
                    {
                        route: 'produccion-mantenimiento-tipo-congelacion',
                        title: 'Tipo Congelacion',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-tipo-congelacion',
                    },

                    {
                        route: 'produccion-mantenimiento-nandina',
                        title: 'Nandina',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-nandina',
                    },

                    {
                        route: 'produccion-mantenimiento-marca',
                        title: 'Marca',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-marca',
                    },

                    {
                        route: 'produccion-mantenimiento-linea',
                        title: 'produccion.mantenimiento.linea',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-linea',
                    },
                    {
                        route: 'produccion-mantenimiento-especie',
                        title: 'produccion.mantenimiento.especie',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-especie',
                    },
                    {
                        route: 'produccion-mantenimiento-tipo-producto',
                        title: 'produccion.mantenimiento.tipo_producto',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-tipo-producto',
                    },
                    {
                        route: 'produccion-mantenimiento-proceso-va',
                        title: 'produccion.mantenimiento.proceso_va',
                        Produccion: 'Produccion',
                        action: 'ver-produccion-mantenimiento-proceso-va',
                    },
                    {
                        route: 'produccion-mantenimiento-estado-producto',
                        title: 'produccion.mantenimiento.estado_producto',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-estado-producto',
                    },
                    {
                        route: 'produccion-mantenimiento-calidad',
                        title: 'produccion.mantenimiento.calidad',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-calidad',
                    },
                    {
                        route: 'produccion-mantenimiento-talla',
                        title: 'produccion.mantenimiento.talla',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-talla',
                    },
                    {
                        route: "produccion-mantenimiento-sublinea",
                        title: "produccion.mantenimiento.sublinea",
                        resource: "Produccion",
                        action: "ver-produccion-mantenimiento-sublinea",
                    },
                    {
                        route: 'produccion-mantenimiento-tratamiento',
                        title: 'produccion.mantenimiento.tratamiento',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-tratamiento',
                    },
                    {
                        route: 'produccion-mantenimiento-certificacion',
                        title: 'produccion.mantenimiento.certificacion',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-certificacion',
                    },
                    {
                        route: 'produccion-mantenimiento-registro-operatividad',
                        title: 'Configuración de Procesos/Equipos de Operatividad',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-registro-operatividad',
                    },
                    {
                        route: 'produccion-mantenimiento-materia-prima',
                        title: 'produccion.mantenimiento.materia_prima',
                        Produccion: 'Produccion',
                        action: 'ver-produccion-mantenimiento-materia-prima',
                    },
                    {
                        route: 'produccion-mantenimiento-presentacion',
                        title: 'produccion.mantenimiento.presentacion',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-presentacion',
                    },
                    {
                        route: 'produccion-mantenimiento-tipo-empaque',
                        title: 'produccion.mantenimiento.tipo_empaque',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-tipo-empaque',
                    },
                    {
                        route: 'produccion-mantenimiento-unidad',
                        title: 'produccion.mantenimiento.unidad',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-unidad',
                    },
                    {
                        route: 'produccion-mantenimiento-item-pt',
                        title: 'produccion.mantenimiento.item_pt',
                        resource: 'Produccion',
                        action: 'ver-produccion-mantenimiento-item-pt',
                    },
                ]

            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Produccion',
                action: 'ver-produccion-transacciones',
                children: [
                    {
                        route: 'produccion-transacciones-transferencias-ingresos',
                        title: 'Ingreso de Materia Prima',
                        resource: 'Produccion',
                        action: 'ver-produccion-ingreso-materia-prima',
                    },
                    {
                        route: 'produccion-transacciones-transferencias-egresos',
                        title: 'Egreso de Materia Prima',
                        resource: 'Produccion',
                        action: 'ver-produccion-egreso-materia-prima',
                    },
                    {
                        route: 'produccion-anulacion-etiqueta',
                        title: 'Anulacion Etiqueta',
                        resource: 'Produccion',
                        action: 'ver-produccion-anulacion-etiqueta',
                    },
                    {
                        route: 'produccion-trazabilidad-etiqueta',
                        title: 'Trazabilidad Etiqueta',
                        resource: 'Produccion',
                        action: 'ver-produccion-trazabilidad-etiqueta',
                    },
                    {
                        route: 'produccion-canasta-etiqueta',
                        title: 'Canasta Etiqueta',
                        resource: 'Produccion',
                        action: 'ver-produccion-canasta-etiqueta',
                    },
                    {
                        route: 'produccion-registro-cabinplant',
                        title: 'Registro Cabinplant',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-cabinplant',
                    },
                    {
                        route: 'produccion-consultar-lote',
                        title: 'Consultar Lote',
                        resource: 'Produccion',
                        action: 'ver-produccion-consultar-lote',
                    },
                    {
                        route: 'produccion-transacciones-liberar-canasta',
                        title: 'Liberar Canasta',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-liberar-canasta',
                    },
                    {
                        route: 'produccion-transacciones-orden-produccion',
                        title: 'Creación de orden',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-orden-produccion',
                    },
                    {
                        route: 'produccion-transacciones-fraccionamiento-va',
                        title: 'Fraccionamiento VA',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-fraccionamiento-va',
                    },
                    {
                        route: 'produccion-transacciones-reembinado',
                        title: 'Reembinamiento',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-reembinado',
                    },
                    {
                        route: 'produccion-transacciones-aprobacion-ordenes-pedido',
                        title: 'Aprobacion de Órdenes de Pedidos',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-aprobacion-ordenes-pedido',
                    },
                    {
                        route: 'produccion-transacciones-bandeja-entrada-proformas',
                        title: 'Bja. etda. Proformas',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-bandeja-entrada-proformas',
                    },
                    {
                        route: 'produccion-transacciones-bandeja-entrada-productos',
                        title: 'Bja. etda. Órdenes',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-bandeja-entrada-productos',
                    },
                    {
                        route: 'produccion-reporte-agrupamientoVA',
                        title: 'Agrupamiento de Etiquetas VA',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-agrupamientova',
                    },
                    {
                        route: 'produccion-transacciones-agrupamientoBines',
                        title: 'Agrupamiento de Bines',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-agrupamientoBines',
                    },
                    {
                        route: 'produccion-transacciones-liquidacion-embarque',
                        title: 'Liquidación Embarque',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-liquidacion-embarque',
                    },
                    {
                        route: 'produccion-transacciones-transferencias-materia-prima',
                        title: 'Transferencias Materia Prima',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-transferencias-materia-prima',
                    },
                    {
                        route: 'produccion-transacciones-registro-operatividad',
                        title: 'Registro de Operatividad',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-registro-operatividad',
                    },
                    {
                        route: 'produccion-transacciones-coches',
                        title: 'Contenedor',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-coches',
                    },
                    {
                        route: 'produccion-transacciones-proformas',
                        title: 'Proformas',
                        resource: 'Produccion',
                        action: 'ver-produccion-transacciones-proformas',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Produccion',
                action: 'ver-produccion-informes',
                children: [
                    {
                        route: 'reporte-rotacion-camaron',
                        title: 'Rotacion Camaron',
                        resource: 'Produccion',
                        action: 'ver-produccion-rotacion-camaron',
                    },
                    {
                        route: 'produccion-reportes-transferenciaMP-kardex',
                        title: 'Kardex',
                        resource: 'Produccion',
                        action: 'ver-produccion-kardex',
                    },
                    {
                        route: 'produccion-reporte-libras',
                        title: 'Libras',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-libras',
                    },
                    {
                        route: 'produccion-reporte-libras-proceso',
                        title: 'Libras X Proceso',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-libras-proceso',
                    },
                    {
                        route: 'produccion-reporte-libras-bodega',
                        title: 'Libras X Bodega',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-libras-bodega',
                    },
                    {
                        route: 'produccion-reporte-etiquetas-lote',
                        title: 'Etiquetas X Lote',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-etiquetas-lote',
                    },
                    {
                        route: 'produccion-reporte-movimiento-bines',
                        title: 'Movimiento de Bines',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-movimiento-bines',
                    },
                    {
                        route: 'produccion-reporte-rendimiento',
                        title: 'Rendimiento',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-rendimiento',
                    },
                    {
                        route: 'produccion-reporte-tiempoEspera',
                        title: 'Tiempo de Espera',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-tiempoEspera',
                    },
                    {
                        route: 'produccion-reporte-TiemposPlantaRecepcion',
                        title: 'Tiempo Planta a Recepción',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-TiemposPlantaRecepcion',
                    },
                    {
                        route: 'produccion-reporte-modifica-anula',
                        title: 'Reporte Control Modificaciones - Anulaciones',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-modificaciones-anulaciones',
                    },
                    {
                        route: 'produccion-reporte-etiquetas-area',
                        title: 'Etiquetas X Area',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-etiquetas-area',
                    },
                    {
                        route: 'produccion-informe-etiquetas-anuladas',
                        title: 'Etiquetas Anuladas',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-informe-etiquetas-anuladas',
                    },
                    {
                        route: 'produccion-informe-tapon',
                        title: 'Tapon',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-informe-tapon',
                    },
                    {
                        route: 'produccion-reporte-Librasreclasificadas',
                        title: 'Libras reclasificadas manualmente',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-Librasreclasificadas',
                    },
                    {
                        route: 'produccion-reporte-LibrasCocido',
                        title: 'Cocido',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-LibrasCocido',
                    },
                    {
                        route: 'produccion-reporte-Tratamiento',
                        title: 'Tratamiento',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-Tratamiento',
                    },
                    {
                        route: 'produccion-reporte-ControldeBalanzas',
                        title: 'Control de Balanzas',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-ControldeBalanzas',
                    },
                    {
                        route: 'produccion-reporteriaMensual',
                        title: 'Reportería Mensual',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteriaMensual',
                    },
                    {
                        route: 'produccion-reporteriaDescabezado',
                        title: 'Reportería Descabezado',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteriaDescabezado',
                    },
                    {
                        route: 'produccion-reporteriaListasDescabezado_rrhh',
                        title: 'Listas Descabezado',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteriaListasDescabezado_rrhh',
                    },
                    {
                        route: 'produccion-reporte-ConsumoHielo',
                        title: 'Consumo de Hielo',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-consumohielo',
                    },
                    {
                        route: 'produccion-reporte-VA-Gavetas',
                        title: 'VA - Gavetas',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-VA-Gavetas',
                    },
                    {
                        route: 'produccion-reporte-BodegaTratado',
                        title: 'Reporte Tratado',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-BodegaTratado',
                    },
                    {
                        route: 'produccion-reporteDiferenciasMP',
                        title: 'Diferencia de MP Liq vs. MP Apl a VA',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteDiferenciasMP',
                    },
                    {
                        route: 'produccion-reporteDiferenciasPT',
                        title: 'Diferencia PT Fresco',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteDiferenciasPT',
                    },
                    {
                        route: 'produccion-reporteEstadoLoteF',
                        title: 'Estado de Lotes Fresco',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporteEstadoLoteF',
                    },
                    {
                        route: 'produccion-reportesLibrasPendientes',
                        title: 'Libras Pendientes',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reportesLibrasPendientes',
                    },
                    {
                        route: 'produccion-reportesBalanzasProfremar',
                        title: 'Pesado por Balanzas',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reportesBalanzasProfremar',
                    },
                    {
                        route: 'produccion-informes-transferencias-materia-prima',
                        title: 'Transferencias Materia Prima',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-informes-transferencias-materia-prima',
                    },
                    {
                        route: 'produccion-reporte-EtiquetasAgrupadasVA',
                        title: 'Etiquetas agrupadas VA',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-EtiquetasAgrupadasVA',
                    },
                    {
                        route: 'produccion-reporte-AgrupamientoBines',
                        title: 'Agrupamiento de Bines',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-AgrupamientoBines',
                    },
                    {
                        route: 'produccion-reporte-AgrupamientoLotes',
                        title: 'Agrupamiento Lotes',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-AgrupamientoLotes',
                    },
                    {
                        route: 'produccion-reporte-Contenedores',
                        title: 'Contenedores',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-Contenedores',
                    },
                    {
                        route: 'produccion-reporte-TipoLotes',
                        title: 'Tipo Lotes',
                        icon: 'ClipboardIcon',
                        resource: 'Produccion',
                        action: 'ver-produccion-reporte-TipoLotes',
                    },
                    {
                        route: 'produccion-reportes-registro-operatividad',
                        title: 'Registro de Operatividad',
                        resource: 'Produccion',
                        action: 'ver-produccion-reportes-registro-operatividad',
                    },
                    {
                        route: 'produccion-reportes-stock-produccion',
                        title: 'Stock Por Plantas',
                        resource: 'Produccion',
                        action: 'ver-produccion-reportes-stock-produccion',
                    },
                ],
            },
        ],
    },
]
